module.exports = __webpack_public_path__ + "static/media/top-offer-banner1.21af50db.jpg";